// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"70bd454d","453":"4149d723"}[chunkId] + ".chunk.js";
};